import React, { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import CellModelOrRecipeParameterFields from "./components/CellModelOrRecipeParameterFields";
import AlternativeStepFields from "./components/AlternativeStepFields";
import Input from "rs-components/Input";
import SelectInput from "rs-components/Input/components/SelectInput";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import { LineGraphElementFormField } from "pages/RS-Workspace/components/Results/components/ElementDialog";
import ResultElementParameterSelect from "../../../ResultElementParameterSelect";
import { parameterTypesSelector } from "store/global/global.selectors";
import { serverErrorsSelector } from "store/knowledge-base-item/knowledge-base-item.selectors";
import { getErrorByPropertyName } from "store/knowledge-base-item/knowledge-base-item.utils";
import { ResultElementParameterType, } from "store/rs-workspace/rs-workspace.types";
import { ParameterFields } from "../../../SpaceViewerElement/types";
import { getCombinationParameterName } from "store/rs-workspace/utils/common.utils";
import { workspaceNotRefinedCellModelsSelector, workspaceRecipesSelector, } from "store/rs-workspace/selectors/rs-workspace.selectors";
import * as styles from "../../styles.module.scss";
const ParameterRow = ({ form, restrictions, parameter, sources }) => {
    const [parameterDialogOpen, setParameterDialogOpen] = useState(false);
    const parameterTypes = useSelector(parameterTypesSelector);
    const recipes = useSelector(workspaceRecipesSelector);
    const cellModels = useSelector(workspaceNotRefinedCellModelsSelector);
    const serverErrors = useSelector(serverErrorsSelector(undefined));
    const parameterName = useMemo(() => getCombinationParameterName(parameter, recipes, cellModels, parameterTypes), [cellModels, parameter, parameterTypes, recipes]);
    const onSubmitParameterSource = useCallback((values) => {
        const parameterValue = {
            id: parameter?.id,
            parameter: values,
        };
        if (values.type === ResultElementParameterType.CELL_MODEL ||
            values.type === ResultElementParameterType.RECIPE) {
            parameterValue.parameter = {
                ...values,
                [ParameterFields.min]: null,
                [ParameterFields.max]: null,
                [ParameterFields.granularity]: null,
            };
        }
        else {
            parameterValue.parameter = {
                ...values,
                [ParameterFields.flowIndexes]: undefined,
            };
        }
        form?.change(LineGraphElementFormField.parameter, parameterValue);
        setParameterDialogOpen(false);
    }, [form, parameter]);
    return (React.createElement("div", { className: classNames(styles.xAxis, styles["edit-mode"]) },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: classNames(styles.cell, styles.parameter) }, "X axis parameter"),
            React.createElement("div", { className: classNames(styles.cell, styles.type) }, "Type"),
            React.createElement("div", { className: classNames(styles.cell, styles.value) }, "Value"),
            React.createElement("div", { className: classNames(styles.cell, styles.unit) }, "Units"),
            React.createElement("div", { className: classNames(styles.cell, styles.range) }, "Range"),
            React.createElement("div", { className: classNames(styles.cell, styles.granularity) }, "Granularity")),
        React.createElement("div", { className: styles.body },
            React.createElement("div", { className: styles.row },
                React.createElement("div", { className: classNames(styles.cell, styles.parameter) },
                    React.createElement(Input, { name: `${LineGraphElementFormField.parameter}.${LineGraphElementFormField.parameter}.${ParameterFields.name}`, component: SelectInput, autoFocus: true, items: [
                            {
                                value: parameterName,
                                label: parameterName,
                            },
                        ], value: parameterName, placeholder: "Select", itemRenderer: SelectItemRenderer, popoverProps: {
                            onInteraction: () => setParameterDialogOpen(true),
                        }, classes: {
                            container: styles.selectWrapper,
                            component: styles.select,
                        }, restrictions: restrictions?.Parameter?.ParameterName, externalError: getErrorByPropertyName(`Request.${LineGraphElementFormField.parameter}.${LineGraphElementFormField.parameter}.${ParameterFields.name}`, serverErrors)?.text }),
                    parameterDialogOpen && (React.createElement(ResultElementParameterSelect, { title: parameter ? "Edit Parameter" : "New parameter", initialValues: (parameter.parameter ?? undefined), noRefinedCellModels: true, allowMultipleUnits: false, allowedTypes: [ResultElementParameterType.RECIPE, ResultElementParameterType.CELL_MODEL], selectedParameters: [], onSubmit: onSubmitParameterSource, restrictions: restrictions?.Parameter, onClose: () => setParameterDialogOpen(false), classes: { target: styles.parameterDialogTarget } }))),
                parameter.parameter?.type === ResultElementParameterType.ALTERNATIVE_FLOW ? (React.createElement(AlternativeStepFields, { parameter: parameter, sources: sources, restrictions: restrictions?.Parameter?.AlternativeFlow })) : (React.createElement(CellModelOrRecipeParameterFields, { parameter: parameter, sources: sources, restrictions: parameter.parameter?.type === ResultElementParameterType.CELL_MODEL
                        ? restrictions?.Parameter?.CellModel
                        : restrictions?.Parameter?.Recipe }))))));
};
export default ParameterRow;
